import React, { Component } from 'react';

class GuitarFilter extends Component {
  state = {};

  onSearchChange = e => {
    const brand = e.target.value;
    this.props.filterGuitars(brand);
  };

  render() {
    const search = this.state.search;
    const brands = this.props.brands || [];

    return (
      <div className="form-group row mt-3">
        <div className="offset-md-2 col-md-4 float-right">
          Select guitar brand:
        </div>
        <div className="col-md-4">
          <select
            className="form-control"
            value={search}
            onChange={this.onSearchChange}
          >
            {brands.map(c => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }
}

export default GuitarFilter;



// WEBPACK FOOTER //
// ./src/main-page/guitar-filter.js